import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { PersonalTokenEffects } from './personal-token/personal-token.effects';
import {
  PersonalTokenNamespace,
  PersonalTokenReducer,
} from './personal-token/personal-token.store';

@NgModule({
  imports: [
    EffectsModule.forFeature([PersonalTokenEffects]),
    StoreModule.forFeature(PersonalTokenNamespace, PersonalTokenReducer),
  ],
})
export class PersonalTokenDataModule {}
